import React from 'react';
import moment from "moment";
import neoLogo from "../../assets/images/Neo_Logo_A.svg";
import { formatCurrency } from "../../utils/format";

/**
 * PrintableReceipt
 * Componente oculto na tela que renderiza o recibo configurado para impressão,
 * com layout otimizado A4 simulando uma nota fiscal/invoice.
 * Exibe logo da empresa, rodapé do NeoApp, consultor, bandeira, e parcelas.
 */
class PrintableReceipt extends React.Component {
    render() {
        const { saleData, memberName, tenantName, tenantLogo } = this.props;

        if (!saleData) return null;



        const dateFormatted = saleData.createdAt?.seconds 
            ? moment(saleData.createdAt.seconds * 1000).format("DD/MM/YYYY HH:mm") 
            : saleData.date 
                ? moment(saleData.date).format("DD/MM/YYYY HH:mm")
                : moment().format("DD/MM/YYYY HH:mm");

        const sellerName = saleData.consultantName || saleData.createdBy?.name || saleData.employeeName || "Não informado";

        return (
            <div style={{ padding: "40px", fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif", color: "#333", backgroundColor: "#fff" }}>
                {/* CABEÇALHO */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #eee", paddingBottom: "20px", marginBottom: "30px" }}>
                    {/* ESQUERDA: Exclusivo para Logo */}
                    <div style={{ flex: "0 0 auto", minWidth: "120px" }}>
                        {tenantLogo && (
                            <img src={tenantLogo} alt="Logo" style={{ maxHeight: "70px", maxWidth: "160px", objectFit: "contain" }} />
                        )}
                    </div>
                    
                    {/* DIREITA: Nome da Empresa e Dados da Venda */}
                    <div style={{ textAlign: "right", flex: "1 1 auto", paddingLeft: "15px" }}>
                        <h2 style={{ margin: "0 0 10px 0", fontSize: "16px", fontWeight: "700", color: "#333", textTransform: "uppercase" }}>{tenantName || "Empresa"}</h2>
                        <h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "600", color: "#111" }}>RECIBO Nº {saleData.saleNumber}</h3>
                        <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#777", textTransform: "uppercase", letterSpacing: "0.5px" }}>Venda / Prestação de Serviço</p>
                        <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}><strong>Data:</strong> {dateFormatted}</p>
                        <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}><strong>Consultor:</strong> {sellerName}</p>
                    </div>
                </div>

                {/* DADOS DO CLIENTE */}
                <div style={{ backgroundColor: "#f8f9fa", padding: "15px 20px", borderRadius: "8px", marginBottom: "30px", border: "1px solid #e9ecef" }}>
                    <h4 style={{ margin: "0 0 10px 0", fontSize: "15px", fontWeight: "600", color: "#444", textTransform: "uppercase", letterSpacing: "0.5px" }}>Informações do Cliente</h4>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                        <p style={{ margin: 0, fontSize: "14px" }}><strong>Nome:</strong> {memberName || saleData.memberName || "Consumidor Misto"}</p>
                        {saleData.memberNumber && <p style={{ margin: 0, fontSize: "14px" }}><strong>ID Cliente:</strong> {saleData.memberNumber}</p>}
                        {/* Espaço reservado para CPF/Email no futuro */}
                    </div>
                </div>

                {/* ITENS */}
                <h4 style={{ margin: "0 0 15px 0", fontSize: "15px", fontWeight: "600", color: "#444", textTransform: "uppercase", borderBottom: "1px solid #ddd", paddingBottom: "8px", letterSpacing: "0.5px" }}>Itens Adquiridos</h4>
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "30px", fontSize: "14px" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#f1f3f5", color: "#495057", textAlign: "left" }}>
                            <th style={{ padding: "12px 15px", fontWeight: "600", borderTopLeftRadius: "6px", borderBottomLeftRadius: "6px" }}>Descrição</th>
                            <th style={{ padding: "12px 15px", fontWeight: "600", textAlign: "center", width: "10%" }}>Qtd</th>
                            <th style={{ padding: "12px 15px", fontWeight: "600", textAlign: "right", width: "20%", borderTopRightRadius: "6px", borderBottomRightRadius: "6px" }}>Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {saleData.items && saleData.items.map((item, idx) => (
                            <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                                <td style={{ padding: "15px", color: "#333" }}>{item.name}</td>
                                <td style={{ padding: "15px", textAlign: "center", color: "#555" }}>{item.quantity || 1}</td>
                                <td style={{ padding: "15px", textAlign: "right", fontWeight: "500", color: "#111" }}>{formatCurrency(item.totalPrice || item.unitPrice)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* DETALHES FINANCEIROS & PAGAMENTOS */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "40px", marginBottom: "40px" }}>
                    
                    {/* PAGAMENTOS */}
                    <div style={{ flex: 1 }}>
                        <h4 style={{ margin: "0 0 15px 0", fontSize: "15px", fontWeight: "600", color: "#444", textTransform: "uppercase", borderBottom: "1px solid #ddd", paddingBottom: "8px", letterSpacing: "0.5px" }}>Formas de Pagamento</h4>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                            <tbody>
                                {saleData.paymentMethods && saleData.paymentMethods.map((p, idx) => (
                                    <tr key={idx} style={{ borderBottom: "1px solid #f8f9fa" }}>
                                        <td style={{ padding: "10px 0", color: "#555", verticalAlign: "middle" }}>
                                            <strong>{p.methodLabel || "Pagamento"}</strong>
                                            {p.brand ? ` • ${p.brand}` : ""}
                                            {p.installments > 1 ? (
                                                <span style={{ display: "block", marginTop: "4px", fontSize: "12px", color: "#777" }}>
                                                    {p.installments}x de {formatCurrency(p.value / p.installments)}
                                                </span>
                                            ) : ""}
                                        </td>
                                        <td style={{ padding: "10px 0", textAlign: "right", fontWeight: "600", color: "#111", verticalAlign: "middle" }}>
                                            {formatCurrency(p.value)}
                                        </td>
                                    </tr>
                                ))}
                                {(!saleData.paymentMethods || saleData.paymentMethods.length === 0) && (
                                    <tr>
                                        <td colSpan="2" style={{ padding: "10px 0", color: "#888", fontStyle: "italic" }}>Nenhum registro de pagamento.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* RESUMO TOTAIS */}
                    <div style={{ width: "280px", backgroundColor: "#f8f9fa", padding: "20px", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                        {parseFloat(saleData.discountTotal) > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px", fontSize: "14px" }}>
                                <span style={{ color: "#666" }}>Subtotal Itens:</span>
                                <span style={{ fontWeight: "500", color: "#333" }}>{formatCurrency((saleData.totalAmount || 0) + (saleData.discountTotal || 0))}</span>
                            </div>
                        )}
                        {parseFloat(saleData.discountTotal) > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px", fontSize: "14px", color: "#e74c3c" }}>
                                <span>Desconto:</span>
                                <span>- {formatCurrency(saleData.discountTotal)}</span>
                            </div>
                        )}
                        <div style={{ display: "flex", justifyContent: "space-between", margin: "15px 0", paddingTop: "15px", borderTop: "1px solid #ddd", fontSize: "18px", fontWeight: "700" }}>
                            <span style={{ color: "#111" }}>Total da Venda:</span>
                            <span style={{ color: "#333" }}>{formatCurrency(saleData.totalAmount)}</span>
                        </div>
                        {parseFloat(saleData.totalPaid) > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px", fontSize: "16px", fontWeight: "600", color: "#2ecc71" }}>
                                <span style={{ color: "#444" }}>TOTAL PAGO:</span>
                                <span>{formatCurrency(saleData.totalPaid)}</span>
                            </div>
                        )}
                        {parseFloat(saleData.balance) > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "12px", paddingTop: "12px", borderTop: "1px dashed #ccc", fontSize: "14px", color: "#f39c12", fontWeight: "600" }}>
                                <span>Saldo Restante a Receber:</span>
                                <span>{formatCurrency(saleData.balance)}</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* RODAPÉ */}
                <div style={{ marginTop: "60px", paddingTop: "20px", borderTop: "2px solid #eee" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                        
                        {/* Credits NeoApp */}
                        <div style={{ textAlign: "right" }}>
                            <p style={{ margin: "0 0 5px 0", fontSize: "11px", fontStyle: "italic", color: "#999" }}>
                                Documento gerencial sem valor fiscal.
                            </p>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginTop: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "700", color: "#aaa", letterSpacing: "1px" }}>POWERED BY</span>
                                <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) opacity(0.6)" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrintableReceipt;
